"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DefaultLayout = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _reactHelmet = require("react-helmet");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _components = require("@PetSureAustralia/petsure-react-ui-library/distLib/components");
var _BrandSwitch = require("@PetSureAustralia/petsure-react-ui-library/distLib/components/UIElements/BrandSwitch/BrandSwitch");
var _brandConfigs = require("@PetSureAustralia/petsure-brand-partner-configs/distConfigs/brandConfigs");
var _gtmService = require("../data/gtmService/gtmService");
var _brandContext = require("../contextProviders/brandContext");
var _store = require("../store");
var _slice = require("../store/quote/slice");
var _slice2 = require("../store/app/slice");
var _steps = require("../constants/app/steps");
var _slice3 = require("../store/form/slice");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var DefaultLayout = exports.DefaultLayout = function DefaultLayout(_ref) {
  var _ref$isLoading = _ref.isLoading,
    isLoading = _ref$isLoading === void 0 ? false : _ref$isLoading;
  var navigate = (0, _reactRouterDom.useNavigate)();
  var _useContext = (0, _react.useContext)(_brandContext.BrandContext),
    showBrandSwitch = _useContext.showBrandSwitch,
    _useContext$activeBra = _useContext.activeBrandContext,
    _useContext$activeBra2 = _useContext$activeBra.brand,
    logos = _useContext$activeBra2.logos,
    brandClassName = _useContext$activeBra2.broker,
    _useContext$activeBra3 = _useContext$activeBra.layout,
    bodyCssClass = _useContext$activeBra3.bodyCssClass,
    header = _useContext$activeBra3.header,
    footer = _useContext$activeBra3.footer;
  var handleBrandSelect = (0, _react.useCallback)(function (activeBrand, brandKey) {
    var _activeBrand$quoteToo, _currentStepDefinitio;
    // TODO: Make store wide reset action.
    _store.store.dispatch((0, _slice.resetQuote)());
    _store.store.dispatch((0, _slice3.resetForm)());
    _store.store.dispatch((0, _slice2.resetSearchParams)());
    var currentStepDefinitions = activeBrand === null || activeBrand === void 0 || (_activeBrand$quoteToo = activeBrand.quoteTools) === null || _activeBrand$quoteToo === void 0 || (_activeBrand$quoteToo = _activeBrand$quoteToo.steps) === null || _activeBrand$quoteToo === void 0 ? void 0 : _activeBrand$quoteToo.StepDefinitions;
    navigate("/".concat((_currentStepDefinitio = currentStepDefinitions.find(function (step) {
      return step.id === (_steps.StepIndex === null || _steps.StepIndex === void 0 ? void 0 : _steps.StepIndex.youAndYourPets);
    })) === null || _currentStepDefinitio === void 0 ? void 0 : _currentStepDefinitio.url));
  }, [navigate]);
  (0, _react.useEffect)(function () {
    var gtmService = (0, _gtmService.getGtmService)();
    var contactNodes = document.querySelectorAll('.customFooterPiece a');
    contactNodes === null || contactNodes === void 0 || contactNodes.forEach(function (node) {
      var _node$href, _node$href2;
      var isMailTo = (_node$href = node.href) === null || _node$href === void 0 ? void 0 : _node$href.toLowerCase().includes('mailto:');
      var isTel = (_node$href2 = node.href) === null || _node$href2 === void 0 ? void 0 : _node$href2.toLowerCase().includes('tel:');
      if (isTel) node.onclick = gtmService.pushGA4EnquiryCall;
      if (isMailTo) node.onclick = gtmService.pushGA4EnquiryMail;
    });
  });
  if (isLoading) {
    return /*#__PURE__*/_react["default"].createElement(_components.LoadingMessage, null);
  }
  var environment = process.env.REACT_APP_ENV;
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_reactHelmet.Helmet, null, /*#__PURE__*/_react["default"].createElement("body", {
    className: "react petSure quoteTool ".concat(bodyCssClass, " ").concat(brandClassName)
  })), environment && environment !== 'prod' && /*#__PURE__*/_react["default"].createElement(_components.Flag, {
    customCssClass: "environmentFlag",
    label: environment
  }), /*#__PURE__*/_react["default"].createElement(_components.MainHeader, _extends({}, header, {
    logos: logos
  })), showBrandSwitch && /*#__PURE__*/_react["default"].createElement(_BrandSwitch.BrandSwitch, {
    customContext: _brandContext.BrandContext,
    brandConfigs: _brandConfigs.BrandConfigs,
    onBrandSelect: handleBrandSelect
  }), /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Outlet, null), /*#__PURE__*/_react["default"].createElement(_components.MainFooter, footer));
};
DefaultLayout.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  user: _propTypes["default"].any,
  // eslint-disable-next-line react/forbid-prop-types
  children: _propTypes["default"].any,
  isLoading: _propTypes["default"].bool,
  headerShouldPin: _propTypes["default"].bool,
  headerPageTitleText: _propTypes["default"].string,
  logoUrl: _propTypes["default"].string,
  forceShowNavLinks: _propTypes["default"].bool,
  bodyCssClass: _propTypes["default"].string
};
DefaultLayout.defaultProps = {
  children: null
};